import Button from "devextreme-react/button";
import { useContext } from "react";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes, ROType } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitVerificationForm } from "../api/submit-verification-form";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function SubmitVerificationFormButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const submitForm = useSubmitVerificationForm(
		order.details.retailOrderID,
		() => {
			showSuccessMessage("Files have been submitted");
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-submit-files' }}
				text={"Submit Files"}
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.InstallerToUploadVerificationForm)}
				disabled={submitForm.isLoading}
				onClick={() => {
					if (!order.details.files.find(x => x.fileTypeID === FileTypes.WorkVerificationForm)) {

						if (order.details.roTypeID === ROType.CabinetInstallOrder) {
							showErrorMessage('Work Verification Form and at least one photo are required');
						}
						else {
							showErrorMessage('Work Verification Form is required');
						}
					}
					else if (order.details.roTypeID === ROType.CabinetInstallOrder &&
						!order.details.files.find(x => x.fileTypeID === FileTypes.DisplayPhoto)) {
						showErrorMessage('At least one photo is required');
					}
					else {
						submitForm.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitForm.isLoading}></LoadPagePanel>
		</>
	)
}
